import { EventAction } from "@directives/_vehicle/journeySummary/journeySummary.component";
import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { IComboBox } from "@interfaces/IComboBox";
import { IGeofence } from "@interfaces/IGeofences";
import { GroupService } from "@services/group.service.ajs";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IGroup } from "../../groups/_models/IGroup";
import "./geofenceList.scss";

interface IGeofenceListBindings {
    geofences: IGeofence[];
    selectedGeofence: IGeofence;
    isShowingZones: boolean;

    onSearch: (args: { geofences: IGeofence[] }) => void;
    onGeofenceMouseEvent: (args: { geofence: IGeofence, eventAction: EventAction }) => void;
}

class GeofenceListComponentController implements angular.IComponentController, IGeofenceListBindings {

    geofences: IGeofence[] = [];
    selectedGeofence: IGeofence;
    isShowingZones: boolean = false;

    filteredGeofences: IGeofence[] = [];
    dropDownfilterOptions: IComboBox[] = [];
    groups: IGroup[] = [];

    onSearch: (args: { geofences: IGeofence[] }) => void;
    onGeofenceMouseEvent: (args: { geofence: IGeofence, eventAction: EventAction }) => void;

    tableHeaders: IVeriTableHeader[] = [];
    tableRows: IVeriTableRow<IGeofence>[] = [];

    static $inject = ["groupService", "veriTableService", "translationService"];

    constructor(
        private readonly groupService: GroupService,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService
    ) { }

    $onInit() {
        this.groupService.getGroups().then(groups => {
            this.groups = groups;
            this.dropDownfilterOptions = this.groupService.getGroupComboBox(groups);
        });

        this.createTableHeaders();
        this.createTableRows();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["geofences"]) {
            this.createTableRows();
        }
    }

    geofenceHistoryUpdated(rows: IVeriListRow<IGeofence>[]) {
        var geofences: IGeofence[] = [];

        rows.forEach(row => {
            geofences.push(row.data);
        });

        if (this.onSearch) {
            this.onSearch({ geofences: geofences });
        }
    }

    geofenceClicked(geofence: IGeofence) {
        if (this.onGeofenceMouseEvent) {
            this.onGeofenceMouseEvent({ geofence: geofence, eventAction: EventAction.Selected });
        }
    }

    geofenceHover(geofence: IGeofence) {
        if (this.onGeofenceMouseEvent) {
            this.onGeofenceMouseEvent({ geofence: geofence, eventAction: EventAction.Hover });
        }
    }

    // -------------------------

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.isShowingZones ? this.translationService.t('GeofenceList.ZoneName') : this.translationService.t('GeofenceList.GeofenceName'), sortable: true, },
            { title: this.translationService.t('Common.Address'), width: 380 },
            { title: this.translationService.t('Common.Tags'), width: 180 },
            //{ title: this.translationService.t('Common.UpdatedOn'), width: 180 }
            this.veriTableService.createDateHeader(this.translationService.t('Common.Updated'))
        ];
    }

    private createTableRows() {
        this.tableRows = [];

        if (this.geofences?.length) {
            this.geofences.forEach(geofence => {
                var row: IVeriTableRow<IGeofence> = {
                    cells: this.createTableRowCells(geofence),
                    data: geofence,
                    searchString: `${geofence?.Addr1}-${geofence?.Addr2}-${geofence?.Addr3}-${geofence?.Addr4}-${geofence?.Description}`
                    //dropDownFilterValues: this.groupService.findGroupIdsAssetBelongsTo(this.groups, vehicle.Id, "VehicleIds")
                };

                this.tableRows.push(row);
            });
        }
    }

    private createTableRowCells(geofence: IGeofence): IVeriTableRowCell[] {
        const cells: IVeriTableRowCell[] = [];

        cells.push({ contents: `${geofence.Description}`, sortData: geofence.Description, sanitize: true });
        cells.push({ contents: geofence.Addr1 ? `${geofence.Addr1} ,  ${geofence.Addr2} ,  ${geofence.Addr3}` : "", sanitize: true });
        cells.push(this.veriTableService.createTagsCell(geofence.Tags, geofence));
        cells.push(this.veriTableService.createDateTimeCell(geofence.Updated || geofence.Created));

        return cells;
    }
}

export class GeofenceListComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            geofences: "<",
            selectedGeofence: "<",
            isShowingZones: "<?",

            onSearch: "&",
            onGeofenceMouseEvent: "&"
        };

        this.controller = GeofenceListComponentController;
        this.template = require("./geofenceList.html");
    }
}
